import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import IconSVG from 'svg-inline-react';
import blacklist from 'blacklist';

import './RadioControl.scss';

class RadioControl extends Component {

    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element
        ]),
        subLabel: PropTypes.string,
        value: PropTypes.string,
        checked: PropTypes.bool.isRequired,
        onChange: PropTypes.func
    };

    static defaultProps = {
        label: '',
        subLabel: '',
        disabled: false,
        value: false,
        name: ''
    };

    state = {
        value: this.props.value
    };

    _onChange = (event) => {
        if (this.props.onChange) {
            this.props.onChange(event, event.target.value);
        }
    };

    render() {
        if (this.props.label) {
            var label = (
                <span className="RadioControl-label">
                    {this.props.label}
                </span>
            );

            if (this.props.subLabel) {
                label = (
                    <span className="RadioControl-label -sublabled">
                        {this.props.label}
                        <br />
                        <span className="RadioControl-sublabel">
                            {this.props.subLabel}
                        </span>
                    </span>
                );
            }
        }

        var iconLink = (this.props.checked ? "radiobtn_on.svg" : "radiobtn_off.svg");
        const props = blacklist(this.props, 'subLabel');

        return (
            <label className={classNames([
                'RadioControl',
                this.props.className
            ])}>
                <input {...props}
                    className="RadioControl-input"
                    type="radio"
                    onChange={this._onChange}
                    value={this.props.value}
                    checked={this.props.checked}
                    disabled={this.props.disabled}
                    name={this.props.name} />
                <div className="RadioControl-box"><IconSVG src={require('!svg-inline!./' + iconLink)} /></div>
                {label}
            </label>
        );
    }

}

export default RadioControl;



// WEBPACK FOOTER //
// ./client/components/RadioControl/RadioControl.js